<div *ngIf="selector" [id]="selector"></div>